module.exports = __webpack_public_path__ + "img/nextarrow.6cab198a.svg";